module.exports = __webpack_public_path__ + "assets/img/sea_food_active.1b1e22d7.png";